<template>
  <div class="main-container">

    <div class="container">
      <div class="column-75 page-middle">
        <h2>Navigation is Prohibited</h2>
        <br>
        <h4>
          <router-link :to="{ name: $store.state.active_view}">Return To Last Page</router-link>
          <br>Or<br>
          <a @click.prevent="reload"><span class="text-underline">Start From Beginning</span></a>
        </h4>
      </div>
    </div>

  </div>
</template>

<script>
    import {elements_classes} from '../mixins/elements_classes'

    export default {
        name: "sorry",
        mixins: [elements_classes],
        data(){
            return{
                // this_page: 'failed'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        },
        methods:{
            reload(){
                window.location.reload()
            }
        }
    }
</script>

<style scoped>
</style>